import { api, headers } from "./api";

const RESOURCE = 'dosen';

export const getsDosen = () => api.get(RESOURCE, headers);

export const searchDosen = (keyword) => api.get(RESOURCE+'/search?keyword='+keyword, headers);